/**
 * Generated by orval 🍺
 * Do not edit manually.
 * SolidOps API
 * OpenAPI spec version: 1.0.0
 */
import * as zod from 'zod';

export const monitoringIntegrationDeleteResponseOutputIdRegExp = new RegExp(
  '^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$',
);

export const MonitoringIntegrationDeleteResponseOutput = zod.object({
  id: zod.uuid().regex(monitoringIntegrationDeleteResponseOutputIdRegExp),
  deleted: zod.literal(true),
});

export type MonitoringIntegrationDeleteResponseOutput = zod.input<
  typeof MonitoringIntegrationDeleteResponseOutput
>;
export type MonitoringIntegrationDeleteResponseOutputOutput = zod.output<
  typeof MonitoringIntegrationDeleteResponseOutput
>;
